/**
 * @typedef {string} ConditionListComparator
 */
import {COMPARATOR} from 'Core/const/global';


/** @typedef {string} ConditionListFieldDisplayType */
export const CONDITION_LIST_FIELD_DISPLAY_TYPE_TEXT = 'TEXT';
export const CONDITION_LIST_FIELD_DISPLAY_TYPE_SELECT = 'SELECT';
export const CONDITION_LIST_FIELD_DISPLAY_TYPE_ASYNC_SELECT = 'ASYNC_SELECT';
export const CONDITION_LIST_FIELD_DISPLAY_TYPE_CUSTOM = 'CUSTOM';
/** @enum {ConditionListFieldDisplayType} */
export const CONDITION_LIST_FIELD_DISPLAY_TYPE = {
	TEXT: CONDITION_LIST_FIELD_DISPLAY_TYPE_TEXT,
	SELECT: CONDITION_LIST_FIELD_DISPLAY_TYPE_SELECT,
	ASYNC_SELECT: CONDITION_LIST_FIELD_DISPLAY_TYPE_ASYNC_SELECT,
	CUSTOM: CONDITION_LIST_FIELD_DISPLAY_TYPE_CUSTOM,
};
/** @type {ConditionListFieldDisplayType[]} */
export const CONDITION_LIST_FIELD_DISPLAY_TYPES = [
	CONDITION_LIST_FIELD_DISPLAY_TYPE_TEXT,
	CONDITION_LIST_FIELD_DISPLAY_TYPE_SELECT,
	CONDITION_LIST_FIELD_DISPLAY_TYPE_ASYNC_SELECT,
	CONDITION_LIST_FIELD_DISPLAY_TYPE_CUSTOM,
];


/** @typedef {string} ConditionListFieldItemDisplayType */
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TEXT = 'TEXT';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_NUMBER = 'NUMBER';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_INTEGER = 'INTEGER';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_BOOLEAN = 'BOOLEAN';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_SELECT = 'SELECT';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_ASYNC_SELECT = 'ASYNC_SELECT';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATE = 'DATE';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TIME = 'TIME';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATETIME = 'DATETIME';
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DAY = 'DAY';
/** @enum {ConditionListFieldItemDisplayType} */
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE = {
	TEXT: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TEXT,
	NUMBER: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_NUMBER,
	INTEGER: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_INTEGER,
	BOOLEAN: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_BOOLEAN,
	SELECT: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_SELECT,
	ASYNC_SELECT: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_ASYNC_SELECT,
	DATE: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATE,
	TIME: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TIME,
	DATETIME: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATETIME,
	DAY: CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DAY,
};
/** @type {ConditionListFieldItemDisplayType[]} */
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPES = [
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TEXT,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_NUMBER,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_INTEGER,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_BOOLEAN,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_SELECT,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_ASYNC_SELECT,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATE,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TIME,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATETIME,
	CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DAY,
];

/**
 * Empty values for condition types
 */
export const CONDITION_LIST_FIELD_ITEM_EMPTY_VALUES = {
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.TEXT]: '',
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.NUMBER]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.INTEGER]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.BOOLEAN]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.SELECT]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.ASYNC_SELECT]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DATE]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.TIME]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DATETIME]: null,
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE.DAY]: '',
};

/**
 * Default condition list item field item condition map based on display type
 */
export const CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_COMPARATOR_MAP = {
	DEFAULT: [
		COMPARATOR.EQ, COMPARATOR.NEQ
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TEXT]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.LIKE, COMPARATOR.STARTS_WITH, COMPARATOR.ENDS_WITH, COMPARATOR.CONTAINS,
		COMPARATOR.NOT_CONTAINS, COMPARATOR.IN, COMPARATOR.NOT_IN
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_NUMBER]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.LT, COMPARATOR.LTE, COMPARATOR.GT, COMPARATOR.GTE, COMPARATOR.IN, 
		COMPARATOR.NOT_IN
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_INTEGER]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.LT, COMPARATOR.LTE, COMPARATOR.GT, COMPARATOR.GTE, COMPARATOR.IN, 
		COMPARATOR.NOT_IN
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_BOOLEAN]: [
		COMPARATOR.EQ, COMPARATOR.NEQ
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_SELECT]: [
		COMPARATOR.EQ, COMPARATOR.NEQ
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_ASYNC_SELECT]: [
		COMPARATOR.EQ, COMPARATOR.NEQ
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATE]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.LT, COMPARATOR.LTE, COMPARATOR.GT, COMPARATOR.GTE
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_TIME]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.LT, COMPARATOR.LTE, COMPARATOR.GT, COMPARATOR.GTE
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DATETIME]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.LT, COMPARATOR.LTE, COMPARATOR.GT, COMPARATOR.GTE
	],
	[CONDITION_LIST_FIELD_ITEM_DISPLAY_TYPE_DAY]: [
		COMPARATOR.EQ, COMPARATOR.NEQ, COMPARATOR.BTW,
	]
};

/** @typedef {string} ConditionListValueClearType */
export const CONDITION_LIST_VALUE_CLEAR_TYPE_NEVER = 'NEVER';
export const CONDITION_LIST_VALUE_CLEAR_TYPE_ALWAYS = 'ALWAYS';
export const CONDITION_LIST_VALUE_CLEAR_TYPE_ON_TYPE_CHANGE = 'ON_TYPE_CHANGE';
/** @enum {ConditionListValueClearType} */
export const CONDITION_LIST_VALUE_CLEAR_TYPE = {
	NEVER: CONDITION_LIST_VALUE_CLEAR_TYPE_NEVER,
	ALWAYS: CONDITION_LIST_VALUE_CLEAR_TYPE_ALWAYS,
	ON_TYPE_CHANGE: CONDITION_LIST_VALUE_CLEAR_TYPE_ON_TYPE_CHANGE,
};
/** @type {ConditionListValueClearType[]} */
export const CONDITION_LIST_VALUE_CLEAR_TYPES = [
	CONDITION_LIST_VALUE_CLEAR_TYPE_NEVER,
	CONDITION_LIST_VALUE_CLEAR_TYPE_ALWAYS,
	CONDITION_LIST_VALUE_CLEAR_TYPE_ON_TYPE_CHANGE,
];